class AdvancedMegamenuImages extends HTMLElement {
  constructor() {
    super();

    this.syncImages = this.syncImages.bind(this);
  }

  connectedCallback() {
    this.syncImages();

    document.addEventListener('shopify:block:load', this.syncImages);
    document.addEventListener('shopify:block:select', this.syncImages);
    document.addEventListener('shopify:section:load', this.syncImages);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:load', this.syncImages);
    document.removeEventListener('shopify:block:select', this.syncImages);
    document.removeEventListener('shopify:section:load', this.syncImages);
  }

  normalize(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  syncImages() {
    /*
     * IMPORTANT :
     * Les menus standards générés par header-menu-desktop.liquid
     * sont des frères de <advanced-megamenu-images>,
     * pas ses enfants.
     *
     * On cherche donc dans le dropdown-group / header complet.
     */
    const searchRoot =
      this.closest('dropdown-group-component') ||
      this.closest('.header__menu-desktop') ||
      document;

    const megamenus = [
      ...searchRoot.querySelectorAll('[data-megamenu-title]'),
    ];

    /*
     * Les images sont initialement dans
     * <advanced-megamenu-images>.
     *
     * On cherche aussi celles qui ont déjà été déplacées,
     * pour que le Theme Editor puisse resynchroniser.
     */
    const images = [
      ...searchRoot.querySelectorAll('[data-megamenu-image]'),
    ];

    images.forEach((image) => {
      const associatedMenu = this.normalize(
        image.dataset.megamenuImage,
      );

      if (!associatedMenu) return;

      const matchingMegamenu = megamenus.find((megamenu) => {
        return (
          this.normalize(megamenu.dataset.megamenuTitle) ===
          associatedMenu
        );
      });

      if (!matchingMegamenu) {
        image.removeAttribute(
          'data-megamenu-image-mounted',
        );

        return;
      }

      const megamenuContent = matchingMegamenu.querySelector(
        '.header__submenu--megamenu__content',
      );

      if (!megamenuContent) {
        image.removeAttribute(
          'data-megamenu-image-mounted',
        );

        return;
      }

      /*
       * Le header-menu-desktop standard n'a pas
       * de zone dédiée aux images.
       *
       * On la crée automatiquement en bas du mégamenu.
       */
      let target = megamenuContent.querySelector(
        ':scope > [data-megamenu-bottom-images]',
      );

      if (!target) {
        target = document.createElement('div');

        target.className =
          'header__megamenu-bottom-images';

        target.setAttribute(
          'data-megamenu-bottom-images',
          '',
        );

        megamenuContent.append(target);
      }

      /*
       * Si l'image est déjà au bon endroit,
       * inutile de la déplacer à nouveau.
       */
      if (image.parentElement !== target) {
        target.append(image);
      }

      image.setAttribute(
        'data-megamenu-image-mounted',
        'true',
      );
    });
  }
}

if (!customElements.get('advanced-megamenu-images')) {
  customElements.define(
    'advanced-megamenu-images',
    AdvancedMegamenuImages,
  );
}